<script setup>
import { UnorderedListOutlined } from '@ant-design/icons-vue';
import { gql } from 'graphql-tag';
import { ref } from 'vue';
import { GqlQuery } from '~/lib/fw';
import PERFIL_ACESSO from '~/perfilAcesso';
import { useDrawerStore } from '~/stores/drawer';

const gerenciaGql = gql`
  query gerenciaQuery {
    cache(where: { partitionKey: { eq: "Cdi" } }) {
      key
      value
    }
  }
`;

const drawerStore = useDrawerStore();
const totalFluxosEmAndamento = ref(null);
const totalFluxosConcluidos = ref(null);
const totalFluxosCancelados = ref(null);
const activeTab = ref('geral');

function abrirFluxos(status) {
  drawerStore.push2({
    componentName: 'CdiGqlDatatable',
    title: 'FLUXOS CDI',
    wrapperStyle: {
      paddingLeft: '8px',
      paddingRight: '8px',
    },
    params: {
      status,
    },
    onClose: async () => {
      await Promise.all([
        totalFluxosEmAndamento.value.update(),
        totalFluxosConcluidos.value.update(),
        totalFluxosCancelados.value.update(),
      ]);
    },
  });
}

const gqlDatatableVars = {
  where: {
    and: [
      {
        responsavel: {
          perfisAcesso: {
            some: {
              perfil: {
                in: [PERFIL_ACESSO.Cdi],
              },
            },
          },
        },
      },
    ],
  },
};
</script>

<template>
  <Page menu="cdi">
    <div class="cdi-page" style="padding-bottom: 24px">
      <a-row justify="center">
        <a-col :xs="24" :md="24" :lg="24" :xl="24">
          <a-row>
            <a-col :span="12">
              <h1>
                <UnorderedListOutlined
                  style="color: #bebcbc; font-size: 18px"
                />
                CDI
              </h1>
            </a-col>
            <a-col :span="12" />
          </a-row>

          <a-tabs
            v-model:active-tab="activeTab"
            :animated="false"
            :destroy-inactive-tab-pane="true"
          >
            <a-tab-pane key="geral" tab="Geral">
              <GqlQuery
                :query-key="['Cdi']"
                :query="gerenciaGql"
                :retry="false"
                :remove-cache-on-unmount="true"
              >
                <template #loading>
                  <GestaoLoadingSkeleton />
                </template>
                <template #default="{ data, isFetching }">
                  <a-spin :spinning="isFetching">
                    <GestaoDashboardView
                      gerencia="Cdi"
                      :data="data.cache"
                      :show-pastas="false"
                    ></GestaoDashboardView>

                    <h2 style="margin-top: 24px">Fluxos</h2>
                    <a-row :gutter="24" style="margin-top: 24px">
                      <a-col :span="8">
                        <TotalFluxosStats
                          ref="totalFluxosEmAndamento"
                          titulo="EM ANDAMENTO"
                          :status="2"
                          :tipos="[14]"
                          @click="() => abrirFluxos(2)"
                        />
                      </a-col>
                      <a-col :span="8">
                        <TotalFluxosStats
                          ref="totalFluxosConcluidos"
                          titulo="CONCLUÍDOS"
                          :status="3"
                          :tipos="[14]"
                          @click="() => abrirFluxos(3)"
                        />
                      </a-col>
                      <a-col :span="8">
                        <TotalFluxosStats
                          ref="totalFluxosCancelados"
                          titulo="CANCELADOS"
                          :status="4"
                          :tipos="[14]"
                          @click="() => abrirFluxos(4)"
                        />
                      </a-col>
                    </a-row>

                    <a-row :gutter="24" style="margin-top: 24px">
                      <a-col :span="12">
                        <TotalSolicitacoesCdiPorTipoChart />
                      </a-col>
                      <a-col :span="12">
                        <TotalSolicitacoesCdiPorUsuarioChart />
                      </a-col>
                    </a-row>
                  </a-spin>
                </template>
              </GqlQuery>
            </a-tab-pane>
            <a-tab-pane key="compromissos" tab="Compromissos">
              <CompromissoGqlDatatable
                :enable-row-selection="true"
                :variables="gqlDatatableVars"
              />
            </a-tab-pane>
          </a-tabs>
        </a-col>
      </a-row>
    </div>
  </Page>
</template>
